import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PaginationBar from './PaginationBar';
import { getActivities, getFavourites, updateFavourite } from '../../../Actions/Dashboard/activities';
import { pingLogin } from '../../../Actions/Dashboard/login';
import ActivityType from '../Components/ActivityType';
import api from '../../../lib/api';

class ActivityBlockObj extends React.Component {
  state = {
    showMore: false,
  };

  updateFavourite = () => {
    this.props.dispatch(updateFavourite(this.props.activity.id));
  }

  showMore = () => {
    this.setState({ showMore: !this.state.showMore });
  }

  render() {
    const { activity } = this.props;
    let img = 'activity-default';
    if (activity.name === 'Natural Choices') img = 'natural-choices-logo';
    else if (activity.name.toLowerCase().indexOf('activate') !== -1) img = 'activate-logo';
    else img = activity.type.toLowerCase().replace(/\W/g, '-');

    return (
      <li className="cb-blog_listing_item">
        <div className={`${this.state.showMore ? 'cb-blog_listing__toggle' : ''}`}>
          <div className="cb-blog_listing_item_wrap">
            <button
              onClick={this.updateFavourite}
              className={`${this.props.favourites.length && this.props.favourites.indexOf(activity.id) !== -1 ?
                'cb-blog_listing_item_fav cb-blog_listing_item_fav_on' :
                'cb-blog_listing_item_fav'}`}
              aria-label="Favourite this activity."
            />
          </div>

          <button onClick={this.showMore} className="cb-blog_listing_item_toggle" aria-label="Toggle this activities contact details." />

          <div className="cb-blog_listing_item_image">
            <img src={`https://www.livewelldorset.co.uk/site/images/activities/${img}.jpg`} alt={activity.name} />
            <div className="cb-blog_listing_item_badge">Free</div>
          </div>

          <div className="cb-blog_listing_item_text">
            <h2 className="h3">{activity.name}</h2>
            <p className="h4">{activity.type}</p>
            <p className="cb-blog_listing_item_text_desc">{activity.description}</p>
            <p className="cb-blog_listing_item_text_link"><button onClick={this.showMore} className="link">Read more</button></p>
            <div className="cb-blog_listing_item_text_inner">
              <p className="large">
                <strong className="colour-highlight"><a data-tel={activity.telephone}>{activity.telephone}</a></strong><br />
                {activity.email ? <strong><a href={`mailto:${activity.email}`} className="wordwrap-break">{activity.email}</a></strong> : ''}
              </p>
              <p className="colour-alt">
                {activity.address1}<br />
                {activity.address2}<br />
                {activity.postcode}
              </p>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

ActivityBlockObj.propTypes = {
  activity: PropTypes.object.isRequired,
};

const ActivityBlock = connect(state => ({
  favourites: state.activityFavourites,
}), dispatch => ({ dispatch }))(ActivityBlockObj);


class RelatedActivities extends React.Component {
  state = {
    showFavourites: false,
    name: '',
    page: 1,
  };

  componentDidMount() {
    this.update = this.update.bind(this);
    if (this.props.login) {
      api.setToken(this.props.login);
      this.props.dispatch(pingLogin(this.props.login.access_token, this.props.login.refresh_token));
    }
    this.update();
    this.props.dispatch(getFavourites());
  }

  componentDidUpdate(prevProps) {
    if (this.props.pathway !== prevProps.pathway) {
      this.update();
      this.setState({ page: 1 }, () => { this.update(); });
    }
    if (this.props.activityfilter !== prevProps.activityfilter) {
      this.setState({ page: 1 }, () => { this.update(); });
    }
  }

  update() {
    this.props.dispatch(getActivities(
      this.props.pathway,
      this.props.activityfilter,
      (this.state.showFavourites ? this.props.activityFavourites : false),
      this.state.name,
      this.state.page,
    ));
  }

  render() {
    return (
      <div className="relatedactivities">
        <div className="header">
          <div className="row">
            <div className="col">
              <ActivityType defaultValue={this.props.activityfilter} />
            </div>
            <div className="col">
              <input type="text" className="input-search" placeholder="Search by keyword" onChange={e => this.setState({ name: e.target.value, page: 1 })} />
              <a onClick={this.update} className="button">Search</a>
            </div>
            <div className="col">
              <a
                className={`${!this.state.showFavourites ? 'fav on' : 'fav'}`}
                onClick={() => {
                  this.setState({ showFavourites: !this.state.showFavourites, page: 1 }, () => {
                    this.update();
                  });
                }}
              >
                { !this.state.showFavourites ? 'Show favourites' : 'Hide Favourites' }
              </a>
            </div>
          </div>
        </div>

        <ul className="cb-blog_listing cb-blog_listing__activity">
          { this.props.activities.data && this.props.activities.data.map(activity => <ActivityBlock key={`activity-${activity.id}`} activity={activity} />)}
        </ul>

        {this.props.activities.data ? <PaginationBar
          total={this.props.activities.last_page}
          currentPage={this.state.page}
          changePage={page => this.setState({ page }, () => { this.update(); })}
        /> : null }
      </div>
    );
  }
}

RelatedActivities.propTypes = {
  dispatch: PropTypes.func.isRequired,
  pathway: PropTypes.string.isRequired,
  activityFavourites: PropTypes.array.isRequired,
};

export default connect(state => ({
  activities: (state.activities ? state.activities : []),
  pathway: state.pathway,
  login: state.login,
  activityfilter: state.activityfilter,
  activityFavourites: (state.activityFavourites ? state.activityFavourites : []),
}), dispatch => ({ dispatch }))(RelatedActivities);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Modules/RelatedActivities.jsx